import { generateID } from '@/lib/utils'
/*eslint-disable*/
class Server {
  private axios: any
  private server: any
  constructor({ axios, server }: any) {
    this.axios = axios
    this.server = server
  }
  public data() {
    this.axiosConfig(this.server)

    return Promise.all([this.getUserInfo(), this.getSpaceName('sys_accountId')]).catch(res => res)
  }

  public getUserInfo() {
    return this.axios
      .get('/webserver/v1/accounts/sys_accountId/getAllInfo', {
        params: {
          to: new Date().getTime(),
        },
      })
      .then(({ data: localdt }: any) => localdt)
  }
  public getSpaceName(id: any) {
    return this.axios.get(`/webserver/v1/accounts/${id}/organizations/org-roles`).then((res: any) => {
      let dtList = res.data.bizUserInfoOutputs,
        spaceName = ''
      for (let i = 0; i < dtList.length; i++) {
        if (dtList[i].isMain) {
          spaceName = dtList[i].orgName
        }
      }

      return spaceName
    })
  }
  public axiosConfig(server: any) {
    this.axios.defaults.withCredentials = true
    this.axios.interceptors.request.use((config: any) => {
      config.baseURL = server
      config.headers = {
        'X-Tsign-Open-Tenant-Id': '',
        'X-Tsign-Open-App-Id': '1111564250',
        'X-Tsign-Client-Id': 'WEB',
        ...config.headers,
      }

      return config
    })
    this.axios.interceptors.response.use(
      (response: any) => {
        if (response.data && response.data.code === 0) return response.data

        return Promise.reject(response.data)
      },
      (error: any) => {
        console.log('qiyu--error:', error)

        return Promise.reject(error)
      }
    )
  }
}

declare let ysf: any

export default class Qiyu {
  public YSF_BTN_HOLDER: any
  constructor({ axios, server, data }: any) {
    this.loadScript()
    this.addStyle()
    this.config({ axios, server, data })
  }

  // 提供外部打开客服
  // TODO  目前暂用定时器代替，以后用 promise + MutationObserver优化
  public open() {
    this.YSF_BTN_HOLDER = this.YSF_BTN_HOLDER || document.getElementById('YSF-BTN-HOLDER') // 判断客服有没有初始化好
    if (this.YSF_BTN_HOLDER) return ysf.open()
    // 客服初始化有延时
    setTimeout(() => {
      ysf.open()
    }, 1000)
  }

  public onready(cb: any) {
    ysf('onready', () => {
      cb && cb()
    })
  }

  public config({ axios, server, data }: any) {
    ysf('onready', async () => {
      this.YSF_BTN_HOLDER = document.getElementById('YSF-BTN-HOLDER')
      const [localdt, spaceName] = await new Server({ axios, server }).data()
      this.ysfConfig(localdt, spaceName, data)
    })
  }

  public configOnSuccess() {
    console.log('qiyu config success')
    // new Promise((resolve, reject) => {
    //   this.onFinish = resolve
    // }).then(() => {
    //   console.log('open')
    //   ysf('open')
    // })
  }

  public addStyle() {
    const style: any = document.createElement('style')
    style.type = 'text/css'
    const styleText = `#YSF-BTN-HOLDER {
      position: fixed;
      max-width: 70px;
      max-height: 70px;
      right: 35px;
      bottom: 270px;
      cursor: pointer;
      overflow: visible;
      filter: alpha(opacity=100);
      opacity: 1;
      z-index: 9990;
    }
    #YSF-CUSTOM-ENTRY-7 {
      position: relative;
      width: auto;
      background-color: #f05050;
      border-radius: 50%;
      box-shadow: 0px 6px 10px 0px rgba(0, 0, 0, 0.25);
    }`
    try {
      style.appendChild(document.createTextNode(styleText))
    } catch (ex) {
      style.styleSheet.cssText = styleText // 针对IE
    }
    const head: any = document.body.parentNode // document.getElementsByTagName('head')[0]
    head.appendChild(style)
  }

  public loadScript() {
    ;(function(w: any, d: any, n, a, j: any = {}) {
      w[n] =
        w[n] ||
        function() {
          return (w[n].a = w[n].a || []).push(arguments)
        }
      j = d.createElement('script')
      j.async = true
      j.src = '//qiyukf.com/script/e7172fc844d88cd3ae196678ea38da5e.js'
      d.body.appendChild(j)
    })(window, document, 'ysf')
  }

  public ysfConfig(localdt: any, spaceName: any, data: any = {}) {
    let qiyuLoginData = localStorage.getItem('qiyu_login_data')
    if (!qiyuLoginData) {
      localStorage.setItem('qiyu_login_data', generateID())
      qiyuLoginData = localStorage.getItem('qiyu_login_data')
    }

    if (localdt && spaceName) {
      ysf('config', {
        uid: localdt && localdt.base ? localdt.base.guid || localdt.base.ouid || localdt.base.uuid : qiyuLoginData, // 用户ID
        robotShuntSwitch: 0, // 关闭机器人优选
        data: JSON.stringify([
          {
            key: 'real_name',
            value: localdt ? localdt.prop.properties.name : '',
          }, // 姓名
          {
            key: 'mobile_phone',
            value: localdt ? localdt.loginInfo.idcard.mobile : '',
          }, // 手机号
          {
            key: 'email',
            value: localdt ? localdt.loginInfo.idcard.email : '',
          }, // 邮箱
          {
            key: 'address',
            value: '',
          }, // 地址
          {
            type: 'idCard',
            key: 'space',
            value: localdt ? localdt.prop.credentials.idno : '',
          }, // 证件号
          {
            type: 'idCard',
            key: 'namespace',
            lable: '所属空间',
            value: spaceName ? spaceName : '',
          }, // 所属空间
          {
            key: 'source_detail',
            lable: '来源详情',
            value: data.tsign_source_detail || '',
          }, // 来源详情
        ]),
        success: () => this.configOnSuccess(),
      })
    } else {
      ysf('config', {
        uid: '', // 用户ID
        robotShuntSwitch: 0,
        data: JSON.stringify([
          {
            key: 'real_name',
            value: '',
          }, // 姓名
          {
            key: 'mobile_phone',
            value: '',
          }, // 手机号
          {
            key: 'email',
            value: '',
          }, // 邮箱
          {
            key: 'address',
            value: '',
          }, // 地址
          {
            type: 'crm_param',
            key: '',
            value: '',
          }, // 自定义字段(sourceType): USER - 注册用户; PURCHASER - 管理员录入
        ]),
        success: () => this.configOnSuccess(),
      })
    }
  }
}
